import React from "react";
import ContactDetails from "Components/layout/container/ContactDetails";
import 'Style/contact.css';
import Navbar from "Components/layout/container/Navbar.js";

class ContactView extends React.Component {
    render() {
        document.body.className = "map-background";
        return (
            <div id="contactPage">
                <Navbar/>
                <ContactDetails />
            </div>
        )
    }
}
export default ContactView;